module.exports = __webpack_public_path__ + "media/banners/cuk_sprawdz_cene-4af3a7e7.jpg";